/**
 * ItemIcon — ícone do item de menu no sidebar azul.
 *
 * Estados visuais:
 *   - Padrão: ícone branco translúcido (`rgba(255,255,255,0.75)`)
 *   - Ativo / atual: ícone branco puro + fundo translúcido sutil
 *   - Quando o drawer está recolhido (só ícones): ícone centralizado
 */
import React from 'react';
import { ListItemIcon } from '@mui/material';

function ItemIcon({ isCurrentPage, isSubmenuOpen, drawerOpen, icon }) {
  const isActive = isCurrentPage || isSubmenuOpen;

  return (
    <ListItemIcon
      sx={{
        // Centraliza quando o drawer está recolhido (só aparecem ícones).
        justifyContent: drawerOpen ? 'flex-start' : 'center',
        // `color` propaga via `currentColor` pra MUI SvgIcons (que usam fill:
        // currentColor) e pra MDI wrappers (configurados com color="currentColor").
        color: isActive ? '#ffffff' : 'rgba(255, 255, 255, 0.78)',
        transition: 'color 0.18s ease',
        // Garante tamanho uniforme: alguns MDI vêm `size=1` (24px), MUI SvgIcon
        // segue o theme override (1.5rem = 24px). Padronizamos pra 22px no menu.
        '& svg': { fontSize: 22, width: 22, height: 22 },
        minWidth: 0,
        marginRight: drawerOpen ? 2 : 0,
        transition: 'margin 0.2s ease',
      }}
    >
      {icon}
    </ListItemIcon>
  );
}

export default ItemIcon;
